import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'app/app.constants';
import { createRequestOption } from 'app/shared/util/request-util';
import { IFileShare, IFileShareSendRequest } from '../../shared/model/file-share.model';

type EntityResponseType = HttpResponse<IFileShare>;
type EntityArrayResponseType = HttpResponse<IFileShare[]>;

@Injectable({ providedIn: 'root' })
export class FileShareService {
  public resourceUrl = SERVER_API_URL + 'api/file-shares';

  constructor(protected http: HttpClient) {}

  send(request: IFileShareSendRequest): Observable<EntityResponseType> {
    return this.http.post<IFileShare>(`${this.resourceUrl}/send`, request, { observe: 'response' });
  }

  resend(id: number, expireHours?: number): Observable<EntityResponseType> {
    let url = `${this.resourceUrl}/${id}/resend`;
    if (expireHours) {
      url += `?expireHours=${expireHours}`;
    }
    return this.http.post<IFileShare>(url, {}, { observe: 'response' });
  }

  findByFile(fileId: number): Observable<EntityArrayResponseType> {
    return this.http.get<IFileShare[]>(`${this.resourceUrl}/by-file/${fileId}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileShare[]>(this.resourceUrl, { params: options, observe: 'response' });
  }
}
